import axiosInstance from 'api/axiosInstance'
import { type Transactions } from 'types/api/transactions'

export const getTransactions = async ({
  filter,
  searchTerm,
  currentPage = 1,
  perPage = 15
}: Transactions) => {
  const { data } = await axiosInstance({
    method: 'GET',
    url: '/api/transactions/history',
    params: {
      perPage,
      page: currentPage,
      type: filter,
      ...(searchTerm ? { keyword: searchTerm } : {})
    }
  })

  return data
}